/* Lumine - collection sort + filter refinement */
(function () {
  var KEEP_SORT = {
    'price-descending': 'Price: High to Low',
    'price-ascending': 'Price: Low to High'
  };
  var SORT_ORDER = ['price-descending', 'price-ascending'];

  /* Filter groups to HIDE, matched on the group's own visible label.
     Anything not named here stays visible, so new filters enabled in
     Search & Discovery appear automatically. */
  var HIDE_FILTERS = ['availability', 'price', 'fabric', 'material'];

  /* ---- Desktop / fallback: prune the native select ---- */
  function pruneSort(select) {
    if (select.dataset.lumineSort === 'done') return;
    select.dataset.lumineSort = 'done';

    var current = select.value;
    var kept = {};

    Array.prototype.slice.call(select.options).forEach(function (o) {
      if (KEEP_SORT[o.value]) kept[o.value] = o;
      o.remove();
    });

    var ph = document.createElement('option');
    ph.value = '';
    ph.textContent = 'Sort By';
    ph.disabled = true;
    select.appendChild(ph);

    SORT_ORDER.forEach(function (v) {
      var o = kept[v];
      if (!o) {
        o = document.createElement('option');
        o.value = v;
      }
      o.textContent = KEEP_SORT[v];
      select.appendChild(o);
    });

    select.value = KEEP_SORT[current] ? current : '';
  }

  /* ---- Drawer: replace the select with a visible list, so sorting reads
         and behaves exactly like the Size and Colour groups ---- */
  function findTemplateItem(wrap) {
    var items = wrap.querySelectorAll('.mobile-facets__item');
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (it.querySelector('.swatch-input-wrapper')) continue;
      if (!it.querySelector('.facet-checkbox__text-label')) continue;
      if (!it.querySelector('input')) continue;
      return it;
    }
    return null;
  }

  function buildDrawerSort(root) {
    var wrap = root.querySelector('#FacetsWrapperMobile');
    if (!wrap) return;

    var select = wrap.querySelector('select[name="sort_by"]');
    if (!select) return;

    var host = select.closest('.js-filter') || select.closest('.mobile-facets__details');
    if (!host || host.dataset.lumineSortList === 'yes') return;

    var tpl = findTemplateItem(wrap);
    if (!tpl) return; /* fail open: leave the native select alone */

    var current = select.value;
    host.dataset.lumineSortList = 'yes';

    var list = document.createElement('ul');
    list.className = 'mobile-facets__list list-unstyled';
    list.setAttribute('role', 'list');

    SORT_ORDER.forEach(function (v, i) {
      var li = tpl.cloneNode(true);
      var input = li.querySelector('input');
      var label = li.querySelector('label');
      var text = li.querySelector('.facet-checkbox__text-label');
      var vh = li.querySelector('.visually-hidden');
      if (vh) vh.remove();

      var id = 'LumineSort-' + i;
      input.type = 'radio';
      input.name = 'sort_by';
      input.value = v;
      input.id = id;
      input.disabled = false;
      input.checked = v === current;

      if (label) {
        label.setAttribute('for', id);
        label.classList.remove('active', 'disabled');
        if (v === current) label.classList.add('active');
      }
      if (text) text.textContent = KEEP_SORT[v];

      list.appendChild(li);
    });

    var heading = document.createElement('div');
    heading.className = 'mobile-facets__summary';
    heading.innerHTML = '<div><span>Sort by</span></div>';

    var panel = document.createElement('div');
    panel.className = 'mobile-facets__submenu';
    panel.appendChild(list);

    host.innerHTML = '';
    host.appendChild(heading);
    host.appendChild(panel);
  }

  function applyFilters(root) {
    var groups = root.querySelectorAll('.js-filter');
    for (var i = 0; i < groups.length; i++) {
      var g = groups[i];
      /* The sort block also carries .js-filter but has no <summary>. */
      var sum = g.querySelector('summary');
      if (!sum) continue;
      var text = (sum.textContent || '').trim().toLowerCase();
      var hide = false;
      for (var j = 0; j < HIDE_FILTERS.length; j++) {
        if (text.indexOf(HIDE_FILTERS[j]) === 0) {
          hide = true;
          break;
        }
      }
      if (hide) {
        g.style.display = 'none';
        continue;
      }
      /* Open drawer groups ONCE, so a shopper who collapses one is not
         fought by the observer re-opening it. */
      if (
        g.classList.contains('mobile-facets__details') &&
        g.dataset.lumineOpened !== 'yes'
      ) {
        g.dataset.lumineOpened = 'yes';
        g.open = true;
      }
    }

    /* Hide the "Filter:" heading if every group ended up hidden. */
    var wrap = root.querySelector('#FacetsWrapperDesktop');
    if (wrap) {
      var visible = 0;
      var all = wrap.querySelectorAll('.js-filter');
      for (var k = 0; k < all.length; k++) {
        if (all[k].style.display !== 'none') visible++;
      }
      var heading = wrap.querySelector('.facets__heading');
      if (heading) heading.style.display = visible === 0 ? 'none' : '';
    }
  }

  var queued = false;
  function run() {
    queued = false;
    applyFilters(document);
    buildDrawerSort(document);
    var selects = document.querySelectorAll('select[name="sort_by"]');
    for (var i = 0; i < selects.length; i++) pruneSort(selects[i]);
  }

  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(run);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
